export default __webpack_public_path__ + "static/media/ls-finance-data.8a4b180d.svg";